import angular from "angular";
import "ua-parser-js";
import "ng-file-upload";
import "angular-file-upload-shim";
import "ng-img-crop-full-extended";

import AppComponent from "./directives/app/app.component";
import AutocompleteComponent from "./directives/autocomplete/autocomplete.component";
import ButtonComponent from "./directives/button/button.component";
import CheckboxComponent from "./directives/checkbox/checkbox.component";
import ColorPickerComponent from "./directives/color-picker/color-picker.component";
import DatePickerComponent from "./directives/date-picker/date-picker.component";
import DropdownListComponent from "./directives/dropdown-list/dropdown-list.component";
import IframeDimensionsComponent from "./directives/iframe/iframe-dimensions.component";
import ReplaceInvalidImageComponent from "./directives/image/replace-invalid-image.component";
import InputContainerComponent from "./directives/input-container/input-container.component";
import InputFilterComponent from "./directives/input-filter/input-filter.component";
import LabelComponent from "./directives/label/label.component";
import LinkComponent from "./directives/link/link.component";
import InitialLoadBannerComponent from "./directives/load-banner/initial-load-banner.component";
import LocationAutocompleteComponent from "./directives/location-autocomplete/location-autocomplete.component";
import LocationFilterComponent from "./directives/location-filter/location-filter.component";
import MoreActionComponent from "./directives/more-action/more-action.component";
import MoreButtonComponent from "./directives/more-button/more-button.component";
import MultiselectFilterComponent from "./directives/multiselect-filter/multiselect-filter.component";
import OptionComponent from "./directives/option/option.component";
import PopoverComponent from "./directives/popover/popover.component";
import RadioButtonComponent from "./directives/radio-button/radio-button.component";
import RemoveAutocomplete from "./directives/remove-autocomplete/remove-autocomplete.component";
import RemoveGoogleAnalytics from "./directives/remove-ga/remove-ga.component";
import RequiredLabelComponent from "./directives/required-label/required-label.component";
import RemoveSpaceComponent from "./directives/rm-space/rm-space.component";
import SimpleScrollbar from "./directives/scroll/simple-scrollbar.component";
import SelectComponent from "./directives/select/select.component";
import ToastComponent from "./directives/toast/toast.component";
import OnVideoEndedComponent from "./directives/video/on-video-ended.component";
import VideoAutoPlayComponent from "./directives/video/video-auto-play.component";

import BackBtnComponent from "./components/back-btn/back-btn.component";
import BreadcrumbComponent from "./components/breadcrumb/breadcrumb.component";
import CalendarComponent from "./components/calendar/calendar.component";
import ChatInputComponent from "./components/chat-input/chat-input.component";
import CollapsibleSectionComponent from "./components/collapsible-section/collapsible-section.component";
import ContentComponent from "./components/content/content.component";
import ContentViewComponent from "./components/content-view/content-view.component";
import CookieBarComponent from "./components/cookie-bar/cookie-bar.component";
import DoubleSliderComponent from "./components/double-slider/double-slider.component";
import EditBtnComponent from "./components/edit-btn/edit-btn.component";
import FooterComponent from "./components/footer/footer.component";
import FormComponent from "./components/form/form.component";
import FormImageComponent from "./components/form-image/form-image.component";
import FormImagesListComponent from "./components/form-images-list/form-images-list.component";
import FormImagePaginationComponent from "./components/form-image-pagination/form-image-pagination.component";
import FormInfoComponent from "./components/form-info/form-info.component";
import GlobalLoadingIndicatorComponent from "./components/global-loading-indicator/global-loading-indicator.component";
import GMapComponent from "./components/gmap/g-map.component";
import ImagesGalleryComponent from "./components/images-gallery/images-gallery.component";
import InfiniteScrollComponent from "./components/infinite-scroll/infinite-scroll.component";
import FormInputGroupComponent from "./components/input-group/input-group.component";
import InputStarsComponent from "./components/input-stars/input-stars.component";
import LogoComponent from "./components/logo/logo.component";
import MainMenuComponent from "./components/main-menu/main-menu.component";
import MainMenuGlobalSearchItemComponent
  from "./components/main-menu-global-search-item/main-menu-global-search-item.component";
import MainMenuHelpItemComponent from "./components/main-menu-help-item/main-menu-help-item.component";
import MainMenuItemComponent from "./components/main-menu-item/main-menu-item.component";
import MainMenuNotificationsItemComponent
  from "./components/main-menu-notifications-item/main-menu-notifications-item.component";
import MainMenuProfileItemComponent from "./components/main-menu-profile-item/main-menu-profile-item.component";
import MenuComponent from "./components/menu/menu.component";
import ModalComponent from "./components/modal/modal.component";
import PageSizeComponent from "./components/page-size/page-size.component";
import PaginationComponent from "./components/pagination/pagination.component";
import PhoneNumberComponent from "./components/phone-number/phone-number.component";
import ProgressCircularComponent from "./components/progress-circular/progress-circular.component";
import ScreenPagesComponent from "./components/screen-pages/screen-pages.component";
import SideFormComponent from "./components/side-form/side-form.component";
import SideMenuComponent from "./components/side-menu/side-menu.component";
import SideMenuItemComponent from "./components/side-menu-item/side-menu-item.component";
import SideMenuSignOutItemComponent from "./components/side-menu-sign-out-item/side-menu-sign-out-item.component";
import SideMenuSignOutToAdminItemComponent from "./components/side-menu-sign-out-to-admin-item/side-menu-sign-out-to-admin-item.component";
import SliderComponent from "./components/slider/slider.component";
import StepperComponent from "./components/stepper/stepper.component";
import StepperContentComponent from "./components/stepper-content/stepper-content.component";
import StepperItemComponent from "./components/stepper-item/stepper-item.component";
import SwitchComponent from "./components/switch/switch.component";
import TabComponent from "./components/tab/tab.component";
import TabsComponent from "./components/tabs/tabs.component";

import ZipCodeValidation from "./validations/address/zip-code.validation";
import MaxValidation from "./validations/number/max.validation";
import MinValidation from "./validations/number/min.validation";
import CardCvcValidation from "./validations/payment/card-cvc.validation";
import CardExpiryDateValidation from "./validations/payment/card-expiry-date.validation";
import CardNameValidation from "./validations/payment/card-name.validation";
import CardNumberValidation from "./validations/payment/card-number.validation";
import PasswordMatchValidation from "./validations/security/password-match.validation";

import SecurityApi from "./resources/security/security.resource";
import AccountsApi from "./resources/accounts/accounts.resource";

import AlertService from "./services/alert/alert.service";
import AuthService from "./services/auth/auth.service";
import BicyclesService from "./services/bicycles/bicycles.service";
import ChangeUrlService from "./services/change-location/change-url.service";
import SecurityService from "./services/change-location/security.service";
import MetainfoService from "./services/change-location/metainfo.service";
import ChatService from "./services/chat/chat.service";
import ChatWsService from "./services/chat/chat-ws.service";
import DateTimeService from "./services/date/date-time.service";
import FileService from "./services/file/file.service";
import GlobalLoadingIndicatorService from "./services/global-loading-indicator/global-loading-indicator.service";
import GMapConfig from "./services/gmap/gmap-config.service";
import HandlersService from "./services/handlers/hendlers-registry.service";
import HistoryService from "./services/history/history.service";
import I18nService from "./services/i18n/i18n.service";
import LocationService from "./services/location/location.service";
import ModalService from "./services/model/modal.service";
import ModalsService from "./modals/modals.service";
import NotificationsService from "./services/notifications/notifications.service";
import NotificationsWsService from "./services/notifications/notifications-ws.service";
import PageableService from "./services/pageable/pageable.service";
import PaymentSourceService from "./services/payment/payment-source.service";
import PhoneService from "./services/phone/phone.service";
import RecaptchaService from "./services/recaptcha/recaptcha.service";
import ResolutionService from "./services/resolution/resolution.service";
import ChangeRouteService from "./services/route/change-route.service";
import PagePermitCheckerService from "./services/security/page-permit-checker.service";
import SideFormService from "./services/side-form/side-form.service";
import LocalStorageService from "./services/storage/local-storage.service";
import SessionStorageService from "./services/storage/session-storage.service";
import ToastService from "./services/toast/toast.service";
import UploadService from "./services/upload/upload.service";

import ClearEmojiFilter from "./filters/clear-emiji.filter";
import EmojiFilter from "./filters/emiji.filter";
import NewLinesFilter from "./filters/new-lines.filter";
import UserAgentFilter from "./filters/user-agent.filter";
import XssFilter from "./filters/xss.filter";

import emojis from "./constants/emoji.constants";

/*import "smartbanner.js/dist/smartbanner.js";
import "smartbanner.js/dist/smartbanner.min.css";*/
import "ng-img-crop-full-extended/compile/minified/ng-img-crop.css";

export default angular.module("vt-shared.module", [
  'ngFileUpload',
  'ngImgCrop',
])
  .directive("vuiApp", AppComponent)
  .directive("vuiAutocomplete", AutocompleteComponent)
  .directive("vuiButton", ButtonComponent)
  .directive("vuiCheckbox", CheckboxComponent)
  .directive("vuiColorPicker", ColorPickerComponent)
  .directive("vuiDatePicker", DatePickerComponent)
  .directive("vuiDropdownList", DropdownListComponent)
  .directive("vuiSetIframeDimensionsOnload", IframeDimensionsComponent)
  .directive("vuiReplaceInvalidImage", ReplaceInvalidImageComponent)
  .directive("vuiInputContainer", InputContainerComponent)
  .directive("vuiInputFilter", InputFilterComponent)
  .directive("vuiLabel", LabelComponent)
  .directive("vuiLink", LinkComponent)
  .directive("vuiInitialLoadBanner", InitialLoadBannerComponent)
  .directive("vuiLocationAutocomplete", LocationAutocompleteComponent)
  .directive("vuiLocationFilter", LocationFilterComponent)
  .directive("vuiMoreAction", MoreActionComponent)
  .directive("vuiMoreButton", MoreButtonComponent)
  .directive("vuiMultiselectFilter", MultiselectFilterComponent)
  .directive("vuiOption", OptionComponent)
  .directive("vuiPopover", PopoverComponent)
  .directive("vuiRadioButton", RadioButtonComponent)
  .directive("vuiRmAutocomplete", RemoveAutocomplete)
  .directive("vuiRmGa", RemoveGoogleAnalytics)
  .directive("vuiRequiredLabel", RequiredLabelComponent)
  .directive("vuiRmSpace", RemoveSpaceComponent)
  .directive("vuiSimpleScrollbar", SimpleScrollbar)
  .directive("vuiSelect", SelectComponent)
  .directive("vuiToast", ToastComponent)
  .directive("vuiOnVideoEnded", OnVideoEndedComponent)
  .directive("vuiVideoAutoPlay", VideoAutoPlayComponent)

  .component("vuiBackBtn", BackBtnComponent)
  .component("vuiBreadcrumb", BreadcrumbComponent)
  .component("vuiCalendar", CalendarComponent)
  .component("vuiChatInput", ChatInputComponent)
  .component("vuiCollapsibleSection", CollapsibleSectionComponent)
  .component("vuiContent", ContentComponent)
  .component("vuiContentView", ContentViewComponent)
  .component("vuiCookieBar", CookieBarComponent)
  .component("vuiDoubleSlider", DoubleSliderComponent)
  .component("vuiEditBtn", EditBtnComponent)
  .component("vuiFooter", FooterComponent)
  .component("vuiForm", FormComponent)
  .component("vuiFormImage", FormImageComponent)
  .component("vuiFormImagesList", FormImagesListComponent)
  .component("vuiFormInfo", FormInfoComponent)
  .component("vuiGlobalLoadingIndicator", GlobalLoadingIndicatorComponent)
  .component("vuiFormImagePagination", FormImagePaginationComponent)
  .component("vuiGMap", GMapComponent)
  .component("vuiImagesGallery", ImagesGalleryComponent)
  .component("vuiInfiniteScroll", InfiniteScrollComponent)
  .component("vuiInputGroup", FormInputGroupComponent)
  .component("vuiInputStars", InputStarsComponent)
  .component("vuiLogo", LogoComponent)
  .component("vuiMainMenu", MainMenuComponent)
  .component("vuiMainMenuGlobalSearchItem", MainMenuGlobalSearchItemComponent)
  .component("vuiMainMenuHelpItem", MainMenuHelpItemComponent)
  .component("vuiMainMenuItem", MainMenuItemComponent)
  .component("vuiMainMenuNotificationsItem", MainMenuNotificationsItemComponent)
  .component("vuiMainMenuProfileItem", MainMenuProfileItemComponent)
  .component("vuiMenu", MenuComponent)
  .component("vuiModal", ModalComponent)
  .component("vuiPageSize", PageSizeComponent)
  .component("vuiPagination", PaginationComponent)
  .component("vuiPhoneNumberInput", PhoneNumberComponent)
  .component("vuiProgressCircular", ProgressCircularComponent)
  .component("vuiScreenPages", ScreenPagesComponent)
  .component("vuiSideForm", SideFormComponent)
  .component("vuiSideMenu", SideMenuComponent)
  .component("vuiSideMenuItem", SideMenuItemComponent)
  .component("vuiSideMenuSignOutItem", SideMenuSignOutItemComponent)
  .component("vuiSideMenuSignOutToAdminItem", SideMenuSignOutToAdminItemComponent)
  .component("vuiSlider", SliderComponent)
  .component("vuiStepper", StepperComponent)
  .component("vuiStepperContent", StepperContentComponent)
  .component("vuiStepperItem", StepperItemComponent)
  .component("vuiSwitch", SwitchComponent)
  .component("vuiTab", TabComponent)
  .component("vuiTabs", TabsComponent)

  .directive("vuiZipCodeValidation", ZipCodeValidation)
  .directive("vuiMax", MaxValidation)
  .directive("vuiMin", MinValidation)
  .directive("vuiCardCvcValidation", CardCvcValidation)
  .directive("vuiCardExpiryDateValidation", CardExpiryDateValidation)
  .directive("vuiCardNameValidation", CardNameValidation)
  .directive("vuiCardNumberValidation", CardNumberValidation)
  .directive("vuiPasswordMatchValidation", PasswordMatchValidation)

  .service("SecurityApi", SecurityApi)
  .service("AccountsApi", AccountsApi)

  .provider("$alert", AlertService)
  .provider("$auth", AuthService)
  .provider("$bicycles", BicyclesService)
  .provider("$metaInfo", MetainfoService)
  .provider("$security", SecurityService)
  .provider("$changeUrlHandler", ChangeUrlService)
  .provider("vuiChatService", ChatService)
  .provider("vuiChatWsService", ChatWsService)
  .provider("$dateTime", DateTimeService)
  .provider("$file", FileService)
  .provider("$gl", GlobalLoadingIndicatorService)
  .provider("vuiModals", ModalsService)
  .provider("gMapConfig", GMapConfig)
  .provider("$handlers", HandlersService)
  .provider("$history", HistoryService)
  .provider("$t", I18nService)
  .provider("vuiLocation", LocationService)
  .provider("vuiModalService", ModalService)
  .provider("vuiNotificationsService", NotificationsService)
  .provider("vuiNotificationsWsService", NotificationsWsService)
  .provider("vuiPageable", PageableService)
  .provider("vuiPaymentSourceService", PaymentSourceService)
  .provider("$phone", PhoneService)
  .provider("$recaptcha", RecaptchaService)
  .provider("vuiResolutionService", ResolutionService)
  .provider("vuiChangeRoute", ChangeRouteService)
  .provider("$pagePermitChecker", PagePermitCheckerService)
  .provider("vuiSideForm", SideFormService)
  .provider("vuiLocalStorage", LocalStorageService)
  .provider("vuiSessionStorage", SessionStorageService)
  .provider("$toast", ToastService)
  .provider("vuiUpload", UploadService)

  .filter("vuiClearEmoji", ClearEmojiFilter)
  .filter("vuiEmoji", EmojiFilter)
  .filter("vuiNewLines", NewLinesFilter)
  .filter("vuiUserAgent", UserAgentFilter)
  .filter("vuiXss", XssFilter)

  .constant("vuiEmojis", emojis);

